export const numeroaLetra = (num) => {
    // Si viene como string con coma, lo convertimos a número
    if (typeof num === 'string') {
        num = parseFloat(num.replace(',', '.'));
    }

    const unidades = ['', 'UN', 'DOS', 'TRES', 'CUATRO', 'CINCO', 'SEIS', 'SIETE', 'OCHO', 'NUEVE'];
    const decenas = ['DIEZ', 'ONCE', 'DOCE', 'TRECE', 'CATORCE', 'QUINCE', 'DIECISEIS', 'DIECISIETE', 'DIECIOCHO', 'DIECINUEVE'];
    const decenasDiez = ['', 'DIEZ', 'VEINTE', 'TREINTA', 'CUARENTA', 'CINCUENTA', 'SESENTA', 'SETENTA', 'OCHENTA', 'NOVENTA'];
    const centenas = ['', 'CIENTO', 'DOSCIENTOS', 'TRESCIENTOS', 'CUATROCIENTOS', 'QUINIENTOS', 'SEISCIENTOS', 'SETECIENTOS', 'OCHOCIENTOS', 'NOVECIENTOS'];

    const convertirSeccion = (n) => {
        let output = '';
        if (n >= 100) {
            if (n === 100) return 'CIEN ';
            output += centenas[Math.floor(n / 100)] + ' ';
            n %= 100;
        }
        if (n >= 10 && n <= 19) {
            output += decenas[n - 10] + ' ';
        } else if (n >= 20) {
            output += decenasDiez[Math.floor(n / 10)];
            if (n % 10 > 0) output += ' Y ' + unidades[n % 10];
            output += ' ';
        } else if (n > 0) {
            output += unidades[n] + ' ';
        }
        return output;
    };

    const procesar = (n) => {
        if (n === 0) return 'CERO';
        if (n === 1) return 'UN';

        let res = '';
        // Billones
        if (n >= 1e12) {
            const billones = Math.floor(n / 1e12);
            res += (billones === 1 ? 'UN BILLON ' : procesar(billones) + 'BILLONES ');
            n %= 1e12;
        }
        // Millones
        if (n >= 1e6) {
            const millones = Math.floor(n / 1e6);
            res += (millones === 1 ? 'UN MILLON ' : convertirSeccion(millones) + 'MILLONES ');
            n %= 1e6;
        }
        // Miles
        if (n >= 1000) {
            const miles = Math.floor(n / 1000);
            res += (miles === 1 ? 'MIL ' : convertirSeccion(miles) + 'MIL ');
            n %= 1000;
        }
        // Resto
        res += convertirSeccion(n);
        return res.trim();
    };

    // Separar parte entera de decimal
    const [entera, decimal] = num.toString().split('.');
    const parteEnteraStr = procesar(parseInt(entera));
    const parteDecimalStr = decimal ? ` CON ${decimal.substring(0, 2)}/100` : '';

    return `${parteEnteraStr}${parteDecimalStr}`.toUpperCase();
};
